export const DEFAULT_SIDEBAR_WIDTH = 230
export const DEFAULT_PER_PAGE = 100